import { inject } from '@angular/core';
import { CognitoService } from '../services/cognito.service';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

export const UserResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(CognitoService).adminGetUser();
};


export const UserCognitoResolver: ResolveFn<any | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return inject(CognitoService).getUserBySub(route.paramMap.get('sub'));
};